<template>
  <div class="container-fluid">
    <div>
      <div class="card">
        <div class="card-header">
          <div class="row">
            <div class="col col-xs-2">
              <h4 class="panel-title">
                <span class="title">Gerenciamento Blacklist E-mails.</span>
                <br/>
                <span class="navigation">Configurações > Blacklist E-mails</span>
              </h4>
            </div>
          </div>
        </div>
        <div class="card-body">
          <form name="form" @submit.prevent="onSubmit">
            <div class="row">
              <div class="col-md-6 mb-2">
                <label for="desc">E-mail:</label>
                <span class="p-fluid">
                  <InputText
                    type="text"
                    id="desc"
                    v-model="blacklistEmail.email"
                  />
                </span>
              </div>
            </div>
            <hr />
            <template>
              <Button
                label="Gravar"
                title="Gravar"
                type="submit"
                class="p-button-primary mr-2 p-button-success"
                icon="pi pi-check"
                :disabled="loading"
              >
              </Button>
            </template>
          </form>
          <hr/>
          <TabView>
            <TabPanel header="Blacklist E-mails">
              <DataTable
                style="min-width: 880px"
                :value="listEmailsBlacklist"
                :paginator="true"
                :rows="4"
                class="p-datatable-responsive"
                :autoLayout="true"
                :filters="filtersModel"
              >
                <Column headerStyle="width: 12em" bodyStyle="text-align: center">
                  <template #body="slotProps">
                    <Button
                      type="button"
                      icon="pi pi-trash"
                      style="margin-right: .5em"
                      @click="deleteEmailBlacklist(slotProps.data.id)"
                    >
                    </Button>
                  </template>
                </Column>
                <Column field="nomeContribuinte" header="Contribuinte">
                  <template #filter>
                    <InputText
                      type="text"
                      v-model="filtersModel['nomeContribuinte']"
                      class="p-column-filter"
                      placeholder="Filtrar por Contribuinte"
                      style="width: 15em"
                    />
                  </template>
                </Column>
                <Column field="email" header="E-mail">
                  <template #filter>
                    <InputText
                      type="text"
                      v-model="filtersModel['email']"
                      class="p-column-filter"
                      placeholder="Filtrar por e-mail"
                      style="width: 10em"
                    />
                  </template>
                </Column>
              </DataTable>
            </TabPanel>
          </TabView>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LoginService from "../services/acesso/login.service";
import NotaFiscalService from "../services/nfse/notafiscal.service";
import BlacklistEmail from "../models/nfse/BlacklistEmails";

export default {
  name: "blacklistEmails",
  data() {
    return {
      currentUser: null,
      loading: false,
      blacklistEmail: new BlacklistEmail(),
      listEmailsBlacklist: [],
      filtersModel: {
        email: ''
      },
    };
  },
  created() {
    this.currentUser = LoginService.currentUserValue;
    this.pesquisar();
  },
  methods: {
    onSubmit() {
      this.loading = true;
      this.salvar();
      this.loading = false;
    },
    salvar() {
      if (!this.blacklistEmail.email) {
        this.$toast.add({
          severity: "warn",
          summary: "Aviso",
          detail: "O campo de e-mail não pode estar vazio!",
          life: 6000
        });
        return;
      }

      NotaFiscalService.saveEmailBlacklist(this.blacklistEmail)
        .then(response => {
          console.log("Resposta da API:", response.data);
          this.$toast.add({
            severity: "success",
            summary: "E-mail adicionado com sucesso!",
            detail: "E-mail adicionado à Blacklist com Sucesso!",
            life: 6000,
            escape: false,
          });

          this.pesquisar();
          this.blacklistEmail.email = "";
        })
        .catch(error => {
          console.error("Erro ao salvar e-mail:", error);

          let errorMessage = "Houve um problema ao adicionar o E-mail!";
          let severityType = "error";

          if (error.response) {
            if (error.response.status === 409) {
              errorMessage = error.response.data;
              severityType = "warn";
            } else {
              errorMessage = error.response.data;
            }
          }

          this.$toast.add({
            severity: severityType,
            summary: severityType === "warn" ? "Aviso" : "Erro",
            detail: errorMessage,
            life: 6000,
          });
        });
    },
    pesquisar(){
      NotaFiscalService.findAllEmailsBlacklist().then(
        response => {
          console.log(response.data);
          this.listEmailsBlacklist = response.data;
        },
        error => {
          let errorMessage = "Houve um problema ao buscar os E-mails!";
          if (error.response) {
            errorMessage = error.response.data;
          }
          this.$toast.add({
            severity: "error",
            summary: errorMessage,
            life: 6000
          });
        }
      )
    },
    deleteEmailBlacklist(idEmailBlacklist){
      NotaFiscalService.deleteEmailBlacklist(idEmailBlacklist).then(
        response => {
          console.log(response.data);
          this.$toast.add({
            severity: "success",
            summary: "E-mail Removido da Blacklist com Sucesso!",
            life: 6000
          });
          this.pesquisar();
        },
        error => {
          let errorMessage = "Houve um problema ao remover o E-mail da Blacklist!";
          if (error.response) {
            errorMessage = error.response.data;
          }
          this.$toast.add({
            severity: "error",
            summary: errorMessage,
            life: 6000
          });
        }
      )
    }
  }
}
</script>

<style scoped>
</style>